import Link from 'next/link';
import { Box } from '@xstyled/styled-components';
import Content from './Content';
import ClientOnly from '@/UI/Primitives/ClientOnly';
import { Container } from '@/UI/Layout/Container';
import { FlexBox } from '@/UI/Primitives/FlexBox';
import { useTranslation } from 'next-i18next';

export default function Menu({ categories }) {
  const { t } = useTranslation();

  return (
    <ClientOnly>
      <Container mb="1rem" display={{ _: 'none', desktop: 'block' }}>
        {categories && (
          <FlexBox as="nav" justify="space-between" whiteSpace="nowrap">
            {categories?.map(category => {
              return <Content key={category.name} category={category} />;
            })}
            <Link href="/brands" passHref>
              <Box
                as="a"
                ml={50}
                fontWeight={500}
                hoverColor="teal-400"
                activeColor="teal-400"
              >
                {t('header.brands')}
              </Box>
            </Link>
          </FlexBox>
        )}
      </Container>
    </ClientOnly>
  );
}
